import { NgModule } from '@angular/core';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {LoadingModule} from 'ngx-loading';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgxPermissionsModule} from 'ngx-permissions';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgMultiSelectDropDownModule} from "ng-multiselect-dropdown";

import { routes }              from './console-applications.routing';
import { ConsoleApplicationsComponent }    from './console-applications.component';
import { ConsoleApplicationsCreateComponent } from './console-applications-create/console-applications-create.component';
import { ConsoleApplicationsEditComponent } from './console-applications-edit/console-applications-edit.component';
import { ConsoleApplicationService }        from "../../services/console-application.service";
import { PipesModule } from "../pipes/pipes.module";
import { MaterialModule } from "../material/material.module";

@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule,
    NgxDatatableModule,
    FormsModule,
    NgMultiSelectDropDownModule,
    LoadingModule,
    NgbModule,
    NgxPermissionsModule.forChild(),
    RouterModule.forChild(routes),
    PipesModule,
    MaterialModule
  ],
  providers: [ConsoleApplicationService],
  declarations: [ ConsoleApplicationsComponent, ConsoleApplicationsCreateComponent, ConsoleApplicationsEditComponent ]
})
export class ConsoleApplicationsModule { }



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/console-applications/console-applications.module.ts